import sensors from 'sa-sdk-javascript';

sensors.init({
    server_url: !/kuaikanmanhua.com/.test(location.href)
        ? 'https://sa.kkmh.com/sa?project=kuaikan_test'
        : 'https://sa.kkmh.com/sa?project=default', //?project=default
    show_log: !/kuaikanmanhua.com/.test(location.href) ? true : false, //线上环境禁止输出埋点信息
    debug_mode: !/kuaikanmanhua.com/.test(location.href) ? false : false,
});

function getUrl(name) {
    var reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i');
    if (reg.test(location.href)) return unescape(RegExp.$2.replace(/\+/g, ' '));
    return '';
}

// 设置公共属性上报
// sensors.registerPage({
// 	cps_parameter: getUrl('cps')
// })
window.sensors = sensors;
window.PLATFORM = 'author';

//测试环境禁用 alert
if (!/kuaikanmanhua.com/.test(location.href)) {
    window.alert = (...ary) => {
        return ary;
    };
}

var sdkTime;
function initTime() {
    window.clearTimeout(sdkTime);

    let user_ids;
    let reg = new RegExp('(^| )uid=([^;]*)(;|$)');
    user_ids = document.cookie.match(reg) && decodeURIComponent(document.cookie.match(reg)[2]);

    if (window.user_ids != 'undefined' && window.user_ids && window.user_ids != '0') {
        user_ids = window.user_ids;
    }
    if (user_ids) {
        sensors.login(user_ids);
    }
    // window.sensors = sensors;
    let distinct_id = sensors.store.getDistinctId().replace(/\s*/g, '');
    if (!distinct_id) {
        // distinct_id==''的情况下 说明是退出登录状态
        sensors.logout(true);
    }
    // sensors.quick('autoTrack', {
    // 	platForm:'pc'
    // });
}
sdkTime = window.setTimeout(initTime, 100);

// sensors.login(user_id);
// sensors.quick('autoTrack');
